import axios from 'axios';
import { useRouter } from 'vue-router';

let baseUrl: string;

switch (true) {
    case window.location.hostname.indexOf('localhost') >= 0:
        baseUrl = 'https://localhost:7162';
        break;
    case window.location.hostname.indexOf('test') >= 0:
        baseUrl = 'https://neu-r4g-app-comp-crm-ap-testing-aqhtbcduedehh5g7.northeurope-01.azurewebsites.net';
        break;
    case window.location.hostname.indexOf('staging') >= 0:
        baseUrl = 'https://neu-r4g-app-comp-crm-ap-staging-btfag9e5cpgndebf.northeurope-01.azurewebsites.net';
        break;   
    default:
        baseUrl = 'https://neu-r4g-app-comp-crm-api-ced7eqhmhcfraweh.northeurope-01.azurewebsites.net';
}

const api = axios.create({
    baseURL: baseUrl,
    withCredentials: true
});

api.interceptors.response.use(
    response => response,
    error => {
        if (error.response.status === 401) {
            console.log('got 401 error from api');
            useRouter().push('/');
        }
        return Promise.reject(error);
    }
);

export default api;